define('views/mypage-view',[
  'jquery',
  'rivets',
  'utils/view',
  'utils/toast',
  'utils/tooltip-init',
  'connections/draft-connection',
  'connections/offer-connection',
  'connections/microshop-connection',
  'connections/order-connection',
  'modules/orders',
  'modules/overlay-box',
  'settings',
  'modules/pop-over'
], function ($, rivets, View, Toast, tooltipInit, DraftConnection, OfferConnection, MicroshopConnection, OrderConnection, Orders, OverlayBox, settings, PopOver) {
  function MyPageView() { }

  MyPageView.prototype.initOffers = function () {
    var _this = this;
    var showMore = { isNeeded: false, all: false };
    var filterProps = ['DisplayName', 'Created'];
    var filterString = '';
    var limit = 5;
    var rivetOffers = [];

    function filterAndRender() {
      var filtered = _this.filter(_this.offers, limit, filterString, filterProps);
      _this.replaceRenderedList(rivetOffers, filtered);
      showMore.isNeeded = filterString ? rivetOffers.length > 5 : _this.offers.length > 5;
      _this.initToolTip();
    }

    rivets.bind($('#mypage-offers'), {
      offers: rivetOffers,
      removeOffer: function (e, line) {
        e.stopPropagation();
        e.preventDefault();

        OfferConnection.removeOffer(line.offer.Id).then(function () {
          // Creates a new list by excepting the deleted one.
          _this.offers = $.grep(_this.offers, function (offer) {
            return offer.Id != line.offer.Id;
          });
          filterAndRender();
        });
      },
      toggleShowAll: function (e, line) {
        showMore.all = !showMore.all;
        limit = showMore.all ? 0 : 5;
        filterAndRender();
      },
      showMore: showMore,
      view: function (e, line) {
        window.location.href = line.offer.URL;
      },
      filter: function (e) {
        e.preventDefault();
        filterString = $(this).find('[type=search]').val();
        filterAndRender();
      }
    });

    OfferConnection.getOfferHeaders().then(function (res) {
      _this.offers = res;
      _this.hideLoader('#mypage-offers');
      filterAndRender();
    });
  };

  /**
   * Gets all user drafts and binds them to the view by rivets.
   * Also binds view draft, remove draft, filter drafts and show more/less.
   */
  MyPageView.prototype.initDrafts = function () {
    var _this = this;
    var showMore = { isNeeded: false, all: false };
    var filterProps = ['DisplayName', 'Created'];
    var filterString = '';
    var limit = 5;
    var rivetDrafts = [];

    function filterAndRender() {
      var filtered = _this.filter(_this.drafts, limit, filterString, filterProps);
      _this.replaceRenderedList(rivetDrafts, filtered);
      showMore.isNeeded = filterString ? rivetDrafts.length > 5 : _this.drafts.length > 5;
      _this.initToolTip();
    }

    DraftConnection.load().then(function (res) {
      _this.drafts = res;
      _this.hideLoader('#mypage-drafts');
      filterAndRender();
    });

    rivets.bind($('#mypage-drafts'), {
      drafts: rivetDrafts,
      removeDraft: function (e, line) {
        e.stopPropagation();
        e.preventDefault();

        DraftConnection.removeDraft(line.draft.Id).then(function () {
          // Creates a new list by excepting the deleted one.
          _this.drafts = $.grep(_this.drafts, function (draft) {
            return draft.Id != line.draft.Id;
          });
          filterAndRender();
        });
      },
      toggleShowAll: function (e, line) {
        showMore.all = !showMore.all;
        limit = showMore.all ? 0 : 5;
        filterAndRender();
      },
      showMore: showMore,
      view: function (e, line) {
        window.location.href = line.draft.URL;
      },
      filter: function (e) {
        e.preventDefault();
        filterString = $(this).find('[type=search]').val();
        filterAndRender();
      }
    });
  };

  /**
   * Gets all user microshops and binds them to the view by rivets.
   * Also binds view draft, remove draft, filter microshops and show more/less.
   */
  MyPageView.prototype.initMicroshops = function () {
    var _this = this;
    var showMore = { isNeeded: false, all: false };
    var filterProps = ['Name'];
    var filterString = '';
    var limit = 4;
    var rivetMicroshops = [];

    function filterAndRender() {
      var filtered = _this.filter(_this.microshops, limit, filterString, filterProps);
      _this.replaceRenderedList(rivetMicroshops, filtered);
      showMore.isNeeded = filterString ? rivetMicroshops.length > 4 : _this.microshops.length > 4;
      _this.initToolTip();
    }

    MicroshopConnection.getMicroshops()
      .then(function (res) {
        if (res && res.microShops) {
          _this.microshops = res.microShops;
          filterAndRender();
        }
      })
      .always(function () {
        _this.hideLoader('#mypage-microshops');
      });

    rivets.bind($('#mypage-microshops'), {
      microshops: rivetMicroshops,
      toggleShowAll: function (e, line) {
        showMore.all = !showMore.all;
        limit = showMore.all ? 0 : 4;
        filterAndRender();
      },
      showMore: showMore,
      view: function (e, line) {
        e.stopPropagation();
        var win = window.open(line.microshop.URL, '_blank');
        if (win) {
          win.focus();
        } else {
          window.location.href = line.microshop.URL;
        }
      },
      users: function (e, line) {
        e.stopPropagation();
        window.location.href = line.microshop.EpiURL + 'Users?shopId=' + line.microshop.Id;
      },
      delete: function (e, line) {
        e.stopPropagation();
        var $popupRemoveShopTemplate = $('#microshop-remove-popup');
        var removeShopPopOver = new PopOver($(document), $popupRemoveShopTemplate);
        removeShopPopOver.show($(this));
        var shopName = line.microshop.Name;
        var masterOrders = parseInt(line.microshop.MasterOrdersPending);
        var orders = parseInt(line.microshop.OrdersPending);
        var $confirmRemove = $('[data-popup-confirm-remove-microshop]');
        var $confirmRemoveText = $('[data-popup-confirm-remove-microshop-text]');

        if (masterOrders > 0 || orders > 0) {
          $confirmRemoveText.text($confirmRemoveText.data('notokdelete'));
          $confirmRemove.hide();
        }
        else {
          $confirmRemoveText.text($confirmRemoveText.data('okdelete'));
          $confirmRemove.text($confirmRemove.data('deletetext') + ' ' + shopName);
          $confirmRemove.show();
          $confirmRemove.on('click', function (e) {
            e.stopPropagation();
            removeShopPopOver.hide();
            MicroshopConnection.removeShop(line.microshop.Id).then(function (res) {
              // Creates a new list by excepting the deleted one.
              _this.microshops = $.grep(_this.microshops, function (s) {
                return s.Id != line.microshop.Id;
              });
              filterAndRender();
            });
          });
        }
      },
      order: function (e, line) {
        e.stopPropagation();
        window.location.href = line.microshop.EpiURL + 'Orders?shopId=' + line.microshop.Id;
      },
      filter: function (e) {
        e.preventDefault();
        filterString = $(this).find('[type=search]').val();
        filterAndRender();
      },
      create: function () {
        window.location.href = settings.microshop + 'Create';
      },
      allshops: function () {
        window.location.href = settings.microshop + 'AllShops';
      },
      edit: function (e, line) {
        window.location.href = line.microshop.EpiURL + 'Edit?shopId=' + line.microshop.Id;
      }
    });
  };

  /**
   * Set a list to render in the view.
   * Empties the earlier list instead of re-setting to keep rivet binding.
   * @param  {Array} list         - the list that is bound to rivets.
   * @param  {Array} replaceList  - the new list that should be replacing it.
   */
  MyPageView.prototype.replaceRenderedList = function (list, replaceList) {
    list.splice(0, list.length);

    $.each(replaceList, function (i, item) {
      list.push(item);
    });
  };

  /**
   * Filters a list by limit and filterString. Returns a shallow copy.
   * @param  {Array} list                - The starting list.
   * @param  {Number} limit              - The highest amount of items the new list should contain.
   * @param  {String} filterString       - The String or substring that has to match the line to be in the new list.
   * @param  {Array|String} filterProps  - The "columns" to look inside. More exactly the key-names of the listed object.
   * @return {Array}                     - A new, possibly smaller array.
   */
  MyPageView.prototype.filter = function (list, limit, filterString, filterProps) {
    var filtered;
    if (filterString) {
      filtered = list.filter(function (line) {
        var match = false;
        $.each(filterProps, function (i, prop) {
          if (line[prop].toLowerCase().indexOf(filterString.toLowerCase()) !== -1) match = true;
        });
        return match;
      });
    }

    if (limit) return (filtered || list).slice(0, limit);
    return filtered || list;
  };

  MyPageView.prototype.initOrders = function () {
    var _this = this;
    var o = new Orders();
    var orderLoader = $('.mypage__orders').find('.mypage__box__loader');

    rivets.bind($('#mypage-orders'), {
      orders: o.orders,
      lastFetch: o.lastFetch,
      loadMore: function () {
        orderLoader.show();
        o.loadAdditional()
          .then(function () {
            _this.initToolTip();
          })
          .always(function () {
            orderLoader.hide();
          });
      },
      search: function (event) {
        event.preventDefault();
        orderLoader.show();
        var $field = $(this).find('[type=search]');
        o.search($field.val())
          .then(function () {
            _this.initToolTip();
          })
          .always(function () {
            orderLoader.hide();
          });
      },
      view: function () {
        o.viewDetails($(this).data('url'));
      },
      viewInvoices: function (e) {
        e.stopPropagation();
        e.preventDefault();
        o.viewDetails($(this).closest('.mypage__orders__row').data('url') + '#invoices');
      },
      getTracking: function (e) {
        e.stopPropagation();
        e.preventDefault();
        o.getTracking($(this), $(this).closest('.mypage__orders__row').data('id'));
      },
      getOrderSubscriptions: function (e) {
        e.stopPropagation();
        e.preventDefault();

        var ob = new OverlayBox($('#orderSubscriptions'), {});
        ob.setup();
        var load = function () {
          $('[data-ordersubscriptions-loader]').show();
          ob.show();
          OrderConnection.getOrderSubscriptions().then(function (resData) {
            var $container = $('[data-ordersubscriptions]');
            $('[data-ordersubscriptions-loader]').hide();
            $container.html(resData);
            $container.find('[data-ordersubscriptions-add]').on("click", addSubscription);
            $container.find('[data-ordersubscriptions-remove]').on("click", deleteSubscription);
            ob.show();
          });
        };
        var deleteSubscription = function (e) {
          var id = $(this).data('ordersubscriptionsRemove');
          OrderConnection.deleteOrderSubscription(id).then(function () {
            load();
          });
        };

        var addSubscription = function () {
          var customerCode = $('[data-ordersubscriptions-add-text]').val();
          OrderConnection.addOrderSubscription(customerCode).then(function (_, __, req) {
            if (req.status === 200) {
              load();
            }
          });
        };

        ob.load(load());
      }
    });

    o.loadAdditional()
      .then(_this.initToolTip)
      .always(function () {
        orderLoader.hide();
      });
  };

  MyPageView.prototype.hideLoader = function (el) {
    $(el).find('.mypage__box__loader').hide();
  };

  MyPageView.prototype.showLoader = function (el) {
    $(el).find('.mypage__box__loader').show();
  };

  MyPageView.prototype.initToolTip = function () {
    // Prevent binding on touch devices.
    if (!Modernizr.touch) tooltipInit($('#mypage-orders'));
    if (!Modernizr.touch) tooltipInit($('#mypage-offers'));
    if (!Modernizr.touch) tooltipInit($('#mypage-drafts'));
    if (!Modernizr.touch) tooltipInit($('#mypage-microshops'));
  };

  return View('MyPageView', function () {
    var mpv = new MyPageView();

    mpv.initOffers();
    mpv.initDrafts();
    mpv.initOrders();
    var shopsExists = $('#my-page-view').data('shop-exist');
    if (shopsExists == 'True') mpv.initMicroshops();
  });
});

